import { invoiceDraftKey } from './invoiceDrafts';

export const isInvoiceSelected = (selected, row) =>
  selected.some((item) => invoiceDraftKey(item) === invoiceDraftKey(row));

export const updateInvoiceSelection = (selected, rows, checked) => {
  const keys = new Set(rows.map(invoiceDraftKey));
  const remaining = selected.filter((item) => !keys.has(invoiceDraftKey(item)));
  if (!checked) return remaining;
  return [...remaining, ...new Map(rows.map((row) => [invoiceDraftKey(row), row])).values()];
};
